import React from 'react'
import { TextProps, Text as ChakraText } from '@chakra-ui/react'

function Text(props: TextProps) {
  return (
    <ChakraText {...props} />
  )
}

export default Text